import { createPromiseAction } from 'redux-saga-promise-actions';
import {
  ReportsResponse,
  ReportsPayload,
  NewReportPayload,
  NewReportResponse,
  PaymentMethodResponse,
  CashFlowTypeResponse,
  UsersFromAgency,
  AgenciesResponse,
} from 'store/types/reports';

export const getReports = createPromiseAction('GET_REPORTS', 'GET_REPORTS_SUCCEEDED', 'GET_REPORTS_FAILURE')<
  ReportsPayload,
  Array<ReportsResponse>,
  undefined
>();

export const getNewReports = createPromiseAction(
  'GET_NEW_REPORTS',
  'GET_NEW_REPORTS_SUCCEEDED',
  'GET_NEW_REPORTS_FAILURE',
)<NewReportPayload, Array<NewReportResponse>, undefined>();

export const getPaymentMethodsReports = createPromiseAction(
  'GET_PAYMENT_METHODS_REPORTS',
  'GET_PAYMENT_METHODS_REPORTS_SUCCEEDED',
  'GET_PAYMENT_METHODS_REPORTS_FAILURE',
)<undefined, Array<PaymentMethodResponse>, undefined>();

export const getCashFlowType = createPromiseAction(
  'GET_CASH_FLOW_TYPE_REPORTS',
  'GET_CASH_FLOW_TYPE_REPORTS_SUCCEEDED',
  'GET_CASH_FLOW_TYPE_REPORTS_FAILURE',
)<undefined, Array<CashFlowTypeResponse>, undefined>();

export const getUsersFromAgency = createPromiseAction(
  'GET_USERS_FROM_AGENCY_REPORTS',
  'GET_USERS_FROM_AGENCY_REPORTS_SUCCEEDED',
  'GET_USERS_FROM_AGENCY_REPORTS_FAILURE',
)<{ agencyId: any }, Array<UsersFromAgency>, undefined>();

export const getAllAgencies = createPromiseAction(
  'GET_ALL_AGENCIES_REPORTS',
  'GET_ALL_AGENCIES_REPORTS_SUCCEEDED',
  'GET_ALL_AGENCIES_REPORTS_FAILURE',
)<undefined, Array<AgenciesResponse>, undefined>();
